import { EntAccountInfo } from '../interfaces/ent-account';
import { getEntAccountInfo } from '@/apis/ent-account';
import { atom } from 'jotai';
import { errorHandler } from '@/utils/request';
import { getDaysLeft } from '@/utils/paid-management';

export const entAccountDataAtom = atom<EntAccountInfo | null>(null);

export const entAccountAtom = atom(
  (get) => ({ entAccount: get(entAccountDataAtom) }),
  (get, set) =>
    getEntAccountInfo()
      .then((entAccount) => {
        set(entAccountDataAtom, entAccount);
      })
      .catch(errorHandler),
);

export const entAccountAvailablePointsAtom = atom((get) => {
  const entAccount = get(entAccountAtom);
  return (
    (entAccount.entAccount?.orderPoints ?? 0) +
    (entAccount.entAccount?.bonusOrderPoints ?? 0) +
    (entAccount.entAccount?.bonusHumanPoints ?? 0)
  );
});

export const entAccountBuyPointsAtom = atom((get) => {
  const entAccount = get(entAccountAtom);
  return entAccount.entAccount?.orderPoints ?? 0;
});

export const entAccountBonusPointsAtom = atom((get) => {
  const entAccount = get(entAccountAtom);
  return (
    (entAccount.entAccount?.bonusOrderPoints ?? 0) + (entAccount.entAccount?.bonusHumanPoints ?? 0)
  );
});

export const entPackageDayLeftAtom = atom((get) => {
  const entAccount = get(entAccountAtom);
  return getDaysLeft(entAccount.entAccount?.packageExpiredAt);
});
